import { TournamentIcon } from './TournamentIcon';

/**
 * author: GreenTurtwig
 * id E2623132-7507-4FFD-8382-E192DDC62D17
 * name tournament
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tournament.svg
 * tags
 * - Gaming / RPG 
 * - Sport 
 */
export const BracketIcon = TournamentIcon;
export default BracketIcon